// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16dOg","col":"styles_col__1ntAS","actions":"styles_actions__2QKyx","conflict":"styles_conflict__1sI4M"};